<template>
    <PersonHeader>
        <!-- 学习报告内容 -->
        <div class="report-content">
            <!-- 学习统计概览 -->
            <div class="stats-overview">
                <div class="total-duration">
                    <div class="duration-label">总时长</div>
                    <div class="duration-value" v-html="hours">
                    </div>
                </div>
                <div class="stats-grid">
                    <div class="stat-item">
                        <div class="stat-label">学习</div>
                        <div class="stat-value"><span>{{getRecordTotalData.days? getRecordTotalData.days : '0'}}</span>天</div>
                        <div class="divider"></div>
                    </div>
                    <div class="stat-item txtCenter">
                        <div class="stat-label">电子书</div>
                        <div class="stat-value"><span>{{getRecordTotalData.bookTotal ? getRecordTotalData.bookTotal : '0'}}</span>本</div>
                        <div class="divider"></div> 
                    </div>
                    <div class="stat-item txtCenter">
                        <div class="stat-label">有声书</div>
                        <div class="stat-value"><span>{{getRecordTotalData.audioTotal ? getRecordTotalData.audioTotal : '0'}}</span>本</div>
                        <div class="divider"></div>
                    </div>
                    <div class="stat-item txtCenter">
                        <div class="stat-label">课程</div>
                        <div class="stat-value"><span>{{getRecordTotalData.courseTotal ? getRecordTotalData.courseTotal : '0'}}</span>门</div>
                    </div>
                </div>
            </div>
            
            <!-- 学习榜单 -->
            <div class="learning-list">
                <div class="list-header"> 
                    <div class="list-title">
                        学习榜单
                    </div>
                    <div class="list-tabs" >
                        <div 
                            class="list-tab-item" 
                            :class="{ active: activeListTab === 'eBook' }"
                            @click="switchListTab('eBook')"
                        >
                            电子书
                        </div>
                        <div 
                            class="list-tab-item" 
                            :class="{ active: activeListTab === 'audioBook' }"
                            @click="switchListTab('audioBook')"
                        >
                            有声书
                        </div>
                        <div 
                            class="list-tab-item" 
                            :class="{ active: activeListTab === 'course' }"
                            @click="switchListTab('course')"
                        >
                            课程
                        </div>
                    </div>
                </div>
                
                <div class="list-content" v-infinite-scroll="loadMore" @scroll="handleScroll" ref="listContainer"
                    infinite-scroll-distance="0">
                    <div 
                        v-for="item in learningItems" 
                        :key="item.id" 
                        class="learning-item"
                    >
                        <div class="item-cover" @click="setupBackRouterPath(item)">
                            <img :src="item.cover"  />
                        </div>
                        <div class="item-info">
                            <div class="item-info-top">
                                <div class="item-title" @click="setupBackRouterPath(item)">{{ item.title }}</div>
                                <div class="item-time" v-html="convertSecondsHours(item.time)"></div>
                            </div>
                            <div class="item-info-bottom">
                                <div class="item-author">{{ item.author }}</div>
                                <div class="item-progress">
                                    <el-progress :text-inside="true" :stroke-width="20" :percentage="Math.round(item.progress * 100)" status="exception" color="#e74c3c" text-color="#fff"></el-progress>
                                </div>
                            </div>
                            
                        </div>
                        
                    </div>
                    <!-- 加载状态提示 -->
                    <div v-if="loading" class="loading-more">
                        <span>加载中...</span>
                    </div>
                </div>
                <!-- 无更多数据提示 -->
                <div v-if="noMore && learningItems&& learningItems.length > 0" class="no-more">
                    已加载全部数据
                </div>
            </div>
        </div>
    </PersonHeader>
</template>

<script>
import PersonHeader from '../../components/PersonHeader.vue'
import api from '@/api/index.js';

export default {
    name: 'studyReport',
    components: {
        PersonHeader,
    },
    data() {
        return {
            activeListTab: 'eBook',
            getRecordTotalData:[],
            hours:'<font class="fontTime">0</font> 小时 <font class="fontTime">0</font> 分钟',
            learningItems: [],
            pageSize:10,
            pageIndex:0,
            loading: false, // 加载中状态
            noMore: false, // 是否无更多数据
            total: 0, // 总数据量
            finished:false,
        }
    },
    created() {
        this.getStudyReportData();
        this.getRecordListData()
    },
    methods: {
        //获取学习报告数据
        getStudyReportData() {
            api.getRecordTotalPC({}).then(res => {
                if(res.status===200){
                    this.getRecordTotalData = res.data.data
                    this.days = this.convertSeconds(this.getRecordTotalData.time)
                    this.hours = this.convertSecondsHours(this.getRecordTotalData.time)
                }
            });
        },
        //天
        convertSeconds(seconds) {
            // 计算小时数
            const hours = Math.floor(seconds / 3600);
            // 计算剩余的分钟数
            const minutes = Math.floor((seconds % 3600) / 60);

            // 计算天数
            const days = seconds / (24 * 3600);
            // 对天数进行向上取整
            const roundedDays = Math.ceil(days);
            // 输出第二种结果：xx 天
            return `${roundedDays}`;
            const result2 = `${roundedDays} 天`;
        },
        //小时
        convertSecondsHours(seconds) {
            // 计算小时数
            const hours = Math.floor(seconds / 3600);
            // 计算剩余的分钟数
            const minutes = Math.ceil((seconds % 3600) / 60);

            // 计算天数
            const days = seconds / (24 * 3600);
            // 对天数进行向上取整
            const roundedDays = Math.ceil(days);

            // 输出第一种结果：xx 小时 xx 分钟
            const result1 = `${hours} 小时 ${minutes} 分钟`;
            // 输出第二种结果：xx 天
            return `<font class="fontTime">${hours}</font> 小时 <font class="fontTime">${minutes}</font> 分钟`;
        },
        //学习报告-下面的列表
        getRecordListData() {
            // 如果正在加载或已无更多数据，则不执行
            if (this.loading || this.noMore) return;
            this.loading = true;
            api.getRecordList({ pageSize: this.pageSize,pageIndex: this.pageIndex,type:this.activeListTab }).then(res => {
                this.loading = false;
                if(res.status===200){
                    this.learningItems = [...this.learningItems, ...res.data.data.data]
                    this.total = res.data.data?.total || 0; // 存储总条数
                    // 判断是否有更多数据
                    this.noMore = this.learningItems.length >= this.total;
                    console.log("this.learningItems.length",this.learningItems.length)
                    console.log("this.total",this.total)
                    console.log("this.pageSize",this.pageSize)
                    if (this.learningItems.length >= this.total || this.total < this.pageSize) {
                        this.finished= true
                    }
                }else{
                    this.loading = false;
                    this.finished= false
                }
            }).catch(() => {
                this.loading = false;
            });
        },
        loadMore() {
            
        },
        handleScroll(e, item) {
            const container = this.$refs.listContainer;
            if (!container) return;
            // 容器高度计算（核心修复）
            const { scrollTop, clientHeight, scrollHeight } = container;
            const scrollableHeight = scrollHeight - clientHeight; // 可滚动的总高度
            const threshold = 200; // 降低阈值，距离底部200px即触发
            if (scrollTop + threshold >= scrollableHeight && !this.loading && !this.noMore) {
                if (this.loading || this.noMore) return;
                if (!this.finished) {
                    this.pageIndex ++
                    this.getRecordListData();
                }
            }
        },
        switchListTab(tab) {
            this.activeListTab = tab
            this.pageIndex = 0;
            this.noMore = false;
            this.finished = false;
            this.learningItems = [];
            // 加载新标签数据
            this.getRecordListData();
        },
        //跳转·详情
        setupBackRouterPath(item){
            if(this.activeListTab == 'eBook'){
                this.$router.push({
                    path: '/ebookdtl',
                    query: {
                        id: item.product_id,
                    }
                })
            }else if(this.activeListTab == 'audioBook'){
                this.$router.push({
                    path: '/Audtl',
                    query: {
                        id: item.product_id,
                    }
                })
            }else if(this.activeListTab == 'course'){
                this.$router.push({
                    path: '/couraudio',
                    query: {
                        id: item.product_id,
                    }
                })
            }
        },
    }
}
</script>

<style scoped lang="scss">
.report-content {
    padding: 20px;

    .stats-overview {
        margin-bottom: 40px;
        background-color: white;
        border-radius: 10px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
        padding: 30px;

        .total-duration {
            margin-bottom: 30px;

            .duration-value {
                color: #333;
                margin-bottom: 5px;
                line-height: 1;
                span{
                    font-size: 32px;
                    font-weight: bold;
                }
            }

            .duration-label {
                font-size: 12px;
                color: #666;
            }
        }

        .stats-grid {
            display: grid;
            grid-template-columns: repeat(5, 1fr);
            gap: 20px;

            .stat-item {
                padding: 20px 10px;
                border-radius: 8px;
                position: relative;

                .stat-value {
                color: #333;
                line-height: 1;
                
                    span {
                        font-size: 32px;
                        font-weight: bold;
                    }
                }

                .stat-label {
                    font-size: 12px;
                    color: #666;
                }

                .divider {
                    position: absolute;
                    right: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 1px;
                    height: 50%;
                    background-color: #e8e8e8;
                }
                
                &.txtCenter {
                    text-align: center;
                }
            }
        }
    }

    .learning-list {
        background-color: white;
        border-radius: 10px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
        padding: 20px 30px;
        min-height: 500px;
        .list-header {
            margin-bottom: 20px;

            .list-title {
                font-size: 18px;
                color: #333;
                display: flex;
                align-items: center;
                margin-bottom: 15px;
            }

            .list-tabs {
                display: flex;
                gap: 10px;
                .list-tab-item {
                    padding: 6px 15px;
                    border-radius: 15px;
                    cursor: pointer;
                    font-size: 14px;
                    color: #666;
                    background-color: white;
                    transition: all 0.3s ease;

                    &:hover {
                        color: #e74c3c;
                    }

                    &.active {
                        background-color: #e74c3c;
                        color: white;
                    }
                }
            }
        }

        .list-content {
            display: flex;
            flex-direction: column;
            gap: 16px;
            height: 500px;
            overflow-y: auto;
            padding-right: 10px; /* 避免滚动条遮挡内容 */
            // 美化滚动条
            &::-webkit-scrollbar {
                width: 6px;
            }
            &::-webkit-scrollbar-thumb {
                background-color: #ddd;
                border-radius: 3px;
            }
            &::-webkit-scrollbar-track {
                background-color: #f5f5f5;
            }
            .learning-item {
                display: flex;
                align-items: center;
                margin-bottom: 0;
                transition: all 0.3s ease;

                &:hover {
                    cursor: pointer;
                }

                .item-cover {
                    width: 70px;
                    height: 100px;
                    margin-right: 18px;
                    flex-shrink: 0;
                    overflow: hidden;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }

                .item-info {
                        flex: 1;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        height: 100px;

                    .item-info-top {
                        display: flex;
                        justify-content: space-between;
                        align-items: flex-start;
                        margin-bottom: 10px;
                        color: #333;

                        .item-title {
                            font-size: 15px;
                            font-weight: 600;
                            line-height: 1.4;
                            flex: 1;
                            margin-right: 16px;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                            overflow: hidden;
                        }

                        .item-time {
                            font-size: 14px;
                            white-space: nowrap;
                            ::v-deep span{
                                font-size: 20px !important; 
                            }
                        }
                    }

                    .item-info-bottom {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;

                        .item-author {
                            font-size: 13px;
                            color: #95a5a6;
                        }

                        .item-progress {
                            width: 30%;
                        }
                    }
                }
            }
        }
        // 加载中样式
        .loading-more {
            padding: 20px;
            text-align: center;
            color: #666;
            display: flex;
            align-items: center;
            justify-content: center;
            
            .el-loading-spinner {
                margin-right: 8px;
                width: 20px;
                height: 20px;
            }
        }

        // 无更多数据样式
        .no-more {
            padding: 15px;
            text-align: center;
            color: #aeaeae;
            font-size: 14px;
        }
    }
}















</style>
<style>
.stats-overview .duration-value .fontTime{
    font-size: 32px;
    font-weight: bold;
}
.item-time {font-size: 14px;white-space: nowrap;}
.item-time font{font-size: 20px !important; }
</style>